export default "__VITE_ASSET__eKfELJ40__"